<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_MainOrderRegistr')"
    width="450px"
    :close-on-click-modal="false"
  >

    <el-scrollbar class="owned-branch-tree" style="height: 400px;">
      <el-tree
        :data="options"
        :props="{ children: 'children', label: 'label' }"
        node-key="value"
        :current-node-key="value"
        highlight-current
        @node-click="handleNodeClick"
      >
        <template slot-scope="{ node, data }">
          <span
            :title="data.tip"
            :style="selectedNodeKey === data.value ? 'color: #1F75D5;font-weight: bold;' : ''"
          >
            {{ node.label }}
          </span>
        </template>
      </el-tree>
    </el-scrollbar>
    <span slot="footer">
      <el-button no="1" @click="innerVisible=false">{{ $t('Message.Close') }}</el-button>
      <el-button type="success" no="2" @click="confirmAssignment">{{ $t('CargoMsg.CARGO_Confirm_Assignment') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { getCacheListByKey, getObjectByCache } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'AssignmentDialog',
  components: { cargoAdvanceSelect },
  props: {
    value: { type: Number, required: true },
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      settingLabel: '',
      options: [],
      width: 0,
      selectedNodeKey: '',
      innerVisible: this.visible
    }
  },
  computed: {
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      this.init()
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    this.readSettingLabel()
    this.init()
  },
  mounted() {
  },
  methods: {
    readSettingLabel() {
      const configs = this.$store.state.settings.partnerLabelSettings
      const curConfig = configs.find(config => config.autoKey === 'auto_office')
      this.settingLabel = Object.keys(curConfig).find(key => typeof curConfig[key] === 'boolean' && curConfig[key])
    },
    async init() {
      const currentOffice = getObjectByCache(TYPE_NAMES.basic_data_Office_All, 'officeId', this.$store.getters.currentOfficeId)
      const officeList = getCacheListByKey(TYPE_NAMES.basic_data_Office_All)
      this.options = []
      officeList.sort((a, b) => {
        const aTime = new Date(a.dateCreated).getTime()
        const bTime = new Date(b.dateCreated).getTime()
        return aTime - bTime
      })
      const optionMap = new Map()
      if (!currentOffice.parentBranchUuid) {
        for (const office of officeList) {
          const option = { value: office.officeId, label: this.getLabel(office) }
          optionMap.set(office.uuid, option)
          if (!office.parentBranchUuid || !optionMap.has(office.parentBranchUuid)) {
            this.options.push(option)
          } else {
            const parentOption = optionMap.get(office.parentBranchUuid)
            if (!parentOption.children) {
              parentOption.children = []
            }
            parentOption.children.push(option)
          }
        }
      } else {
        for (const office of officeList) {
          const option = { value: office.officeId, label: this.getLabel(office) }
          optionMap.set(office.uuid, option)
          if (office.parentBranchUuid === currentOffice.parentBranchUuid) {
            this.options.push(option)
          } else {
            const parentOption = optionMap.get(office.parentBranchUuid)
            if (parentOption && !parentOption.children) {
              parentOption.children = []
            }
            if (parentOption) {
              parentOption.children.push(option)
            }
          }
        }
      }
    },
    getLabel(office) {
      let txt = ''
      switch (this.settingLabel) {
        case 'chineseName':
          txt = office.chineseName
          break
        case 'englishName':
          txt = office.englishName
          break
        default:
          txt = office.chineseName
          break
      }
      return txt
    },
    getLabelTip(office) {
      let tip = ''
      switch (this.settingLabel) {
        case 'chineseName':
          tip = office.code
          break
        case 'englishName':
          tip = office.code
          break
        default:
          tip = this.$getLangColumn(office)
          break
      }
      return tip
    },
    handleNodeClick(data) {
      this.selectedNodeKey = data.value
    },
    confirmAssignment() {
      if (this.selectedNodeKey != null) {
        this.$emit('returnCallBack', this.selectedNodeKey)
      }
      this.selectedNodeKey = ''
      this.innerVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
.assignment-dialog {

}
.owned-branch-tree.el-scrollbar {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>
